// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SignInExistingAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInExistingAccount";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { screen } from "@rugby/XDL/Helpers";
import { color, hexToRGB } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

interface XngSignInStyles {
    main?: any;
    content?: InjectableCss;
    signInExistingAccountTitle?: InjectableCss;
    userNameWrapper?: InjectableCss;
    passwordWrapper?: InjectableCss;
    forgetPasswordWrapper?: InjectableCss;
    sginInWrapper?: InjectableCss;
    newToRugbyWrapperStyle?: InjectableCss;
}

interface RegistrationStyleInterface {
    newToRugbyStyle?: InjectableCss;
    registrationLinkStyle?: LinkPresentationProps;
}

interface XngSignInExistingAccountStylesInterface extends SignInExistingAccountStyles {
    changePasswordModal?: ModalPresentationProps;
    registrationStyle?: RegistrationStyleInterface;
    loadingOverlay?: LoadingOverlayProps;
}

export const xngSignInExistingAccountStyles: XngSignInExistingAccountStylesInterface = {
    icon: {
        css: css`
            padding-top: 50px;
        `,
    },
    signInButton: {
        sizeVariant: "small",
        css: css`
            min-width: 134px;
        `,
    },
    resetPasswordModal: {
        sizeVariant: "small",
    },
    registrationStyle: {
        newToRugbyStyle: {
            css: css`
                color: ${getColor("common.white")};
                font-size: 14px;
                line-height: 17px;
                text-align: center;
                text-shadow: 0 1px 1px 0
                    ${({ theme }: { theme: BaseTheme }) => hexToRGB(getColor("text.main")({ theme }), 0.5)};
            `,
        },
        registrationLinkStyle: {
            color: "common.white",
            typographyProps: {
                weight: "bold",
            },
            hoverStyle: {
                color: color("text.main", 0.8)(),
            },
            icon: {
                iconProps: {
                    color: "common.white",
                    src: ChevronRight,
                    size: 14,
                    css: css`
                        margin-right: 0;
                        margin-left: 10px;
                    `,
                },
                position: "left",
            },
        },
    },
    loadingOverlay: {
        css: css`
            width: 100%;
        `,
    },
    rememberMeCheckbox: {
        css: css`
            padding-top: 6px;
            & label {
                color: #424342;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 17px;
                margin-left: 5px !important;
            }
        `,
    },
};

export const signInStyles: XngSignInStyles = {
    main: {
        css: css`
            min-width: 290px;
            max-width: 300px;
            padding: 10px;
            background: ${getColor("common.white")};
            position: relative;
            ${screen("lte", "sm")`
                max-width: initial;
                padding: 0;
            `};
        `,
    },
    content: {
        css: css`
            ${screen("lte", "sm")`
                padding: 0 20px;
            `};
        `,
    },
    signInExistingAccountTitle: {
        css: css`
            letter-spacing: 0;
            line-height: 30px;
            text-transform: capitalize;
        `,
    },
    userNameWrapper: {
        css: css`
            margin-bottom: 25px;
        `,
    },
    passwordWrapper: {
        css: css`
            margin-bottom: 15px;
        `,
    },
    forgetPasswordWrapper: {
        css: css`
            margin-bottom: 25px;
            display: flex;
            justify-content: flex-end;
        `,
    },
    sginInWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        `,
    },
    newToRugbyWrapperStyle: {
        css: css`
            overflow: visible;
            display: flex;
            flex-direction: row;
            padding: 15px;
            overflow-wrap: break-word;
            word-break: break-word;
            flex-basis: 100%;
            max-width: 100%;
            border-bottom-left-radius: 3px;
            border-bottom-right-radius: 3px;
            background-color: rgb(134, 157, 162);
            border: 1px solid rgba(0, 122, 184, 0.05);
            box-shadow: rgba(80, 106, 113, 0.25) 0px 0px 15px 0px;
            position: absolute;
            bottom: -20px;
            left: 50%;
            transform: translate(-50%, 100%);
            width: 270px;
            -webkit-box-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            align-items: center;

            ${screen("lte", "sm")`
                bottom: -60px;
                width: 100%;
                border-radius: 0;
            `};
        `,
    },
};
